import {http} from '@/axios'

function getInitState() {
  return {
    pending: false,
    loaded: false,
    promiseSettings: null,
    settings: {},
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  getters: {},
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return
      state[key] = value
    }
  },
  actions: {
    load({state, commit}) {
      if (state.loaded) return Promise.resolve()

      if (state.pending) {
        return state.promiseSettings
      }

      commit('setProperty', ['pending', true])

      const promiseSettings = http.get('/api/setting/settings')
        .then(({data}) => {
          commit('setProperty', ['settings', data.data])
        })
        .finally(() => {
          commit('setProperty', ['loaded', true])
          commit('setProperty', ['pending', false])
          commit('setProperty', ['promiseSettings', null])
        })

      commit('setProperty', ['promiseSettings', promiseSettings])

      return promiseSettings
    }
  }
}
